<template>
  <div class="app-main-content billing-native">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" type="card" style="width:100%">
        <el-tab-pane v-if="$checkPermission(['tab_ACTBilling_tabChargeList'])" :label="$t('CargoMsg.Cargo_Reconciliation')" name="tabReconciliation" :lazy="true">
          <tab-reconciliation />
        </el-tab-pane>
        <el-tab-pane v-if="$checkPermission(['tab_ACTBilling_tabBillingList'])" :label="$t('CargoMsg.Cargo_Bill')" name="tabBilling" :lazy="true">
          <tab-billing />
        </el-tab-pane>
        <el-tab-pane v-if="$checkPermission(['tab_ACTBilling_tabBillingGroupList'])" :label="$t('CargoMsg.Cargo_AccountStatement')" name="tabBillingGroup" :lazy="true">
          <tab-billing-group />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import tabBilling from './components/BillingNative/tabBilling'
import tabBillingGroup from './components/BillingNative/tabBillingGroup'
import tabReconciliation from './components/BillingNative/tabReconciliation'

export default {
  name: 'BillingNative',
  components: { tabBilling, tabBillingGroup, tabReconciliation },
  data() {
    return {
      activeTabName: 'tabReconciliation'
    }
  },
  beforeMount() {
    const tabChargeList = this.$checkPermission(['tab_ACTBilling_tabChargeList'])
    const tabBillingList = this.$checkPermission(['tab_ACTBilling_tabBillingList'])
    const tabBillingGroupList = this.$checkPermission(['tab_ACTBilling_tabBillingGroupList'])
    if (!tabChargeList) {
      if (tabBillingList) {
        this.activeTabName = 'tabBilling'
      } else {
        if (tabBillingGroupList) {
          this.activeTabName = 'tabBillingGroup'
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
